import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ImgUrlCreationService } from '../shared/services/img-url-creation.service';
import { DataService } from '../shared/services/data.service';
import { KlaHttpService } from '../shared/tools/services/kla.http.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MenuToggleLinkDirective} from '../core/menu-toggle/menu-toggle-link.directive';
import { MenuToggleAnchorDirective} from '../core/menu-toggle/menu-toggle-anchor.directive';
import { MenuToggleDirective } from '../core/menu-toggle/menu-toggle.directive';

declare var $: any;

@Component({
  selector: 'angly-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [ CommonModule, RouterModule, MenuToggleDirective, MenuToggleAnchorDirective, MenuToggleLinkDirective]
})
export class MenuComponent implements OnInit, AfterViewInit {

  searchActive = false;
  public logo = DataService.LOGO_DATA;
  public menuItems;
  public isMaintenance: boolean;
  public headerStyle = {
    'background-color': DataService.getData().theme['5'].colors.headerColor
  };
  public itemStyle = {
    'color': DataService.getData().theme['5'].colors.headerItemsColor
  };
  public hamburgerColor = DataService.getData().theme['5'].colors.headerItemsColor;

  isLivePreview = DataService.isLivePreview;

  public logoPath: string;

  defaultUrl = DataService.DEFAULT_PAGE_URL;

  constructor(
    public router: Router,
    private httpService: KlaHttpService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    DataService._isMaintenance.subscribe(res => {
      this.isMaintenance = res;
    });
  }

  ngOnInit() {
    this.menuItems = DataService.HEADER_MENU_ITEMS;
    if (isPlatformBrowser(this.platformId)) {
      const imageConfig = {
        id: this.logo.image,
        width: 500,
        height: +this.logo.height,
        cropConfig: this.logo.crop_config
      };
      if (imageConfig.cropConfig && (imageConfig.width || imageConfig.height)) {
        this.logoPath = this.httpService.getCroppedImagePath(imageConfig);
      } else {
        this.logoPath = this.httpService.getImagePath(imageConfig.id, 500);
      }
    }
    this.isMaintenance = DataService.isMaintenance;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isMaintenance = DataService.isMaintenance;
    }, 2000);
    this.isMaintenance = DataService.isMaintenance;
  }

  searchActiveFunction() {
    this.searchActive = !this.searchActive;
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.searchActive = false;
    }
  }

  public removeCollapseInClass() {
    $('#navbarCollapse').removeClass('show');
  }

  createImgUrl(id, specs) {
    return ImgUrlCreationService.createImgUrl(id, specs);
  }

  getTargetValue(layout) {
    let pages = DataService.getData().default?.pages ? DataService.getData().default?.pages : DataService.getData().pages;
    let externalPage = pages?.find(page => page.layout == layout);
    if(externalPage.targetBlank) {
      return '_blank'
    } else return '_self'
  }
}
